import Cookies from 'js-cookie';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initAnnouncementBar = (context) => {
  const announcementBarSection = context.closest('.shopify-section');
  if (!announcementBarSection) return;

  const headerHeightChangeEvent = new Event('headerHeightChange');
  const closedAnnouncement = Cookies.get('CLOSED_ANNOUNCEMENT') == 'true' ? true : false;
  if (!closedAnnouncement) {
    $(context).slideDown(250, () => {
      context.style.display = '';
      context.classList.remove('hidden');
      window.dispatchEvent(headerHeightChangeEvent);
    });
  }

  const closeIcon = announcementBarSection.querySelector('.announcement-bar__close-icon');
  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      Cookies.set('CLOSED_ANNOUNCEMENT', 'true');
      $(context).slideUp(250, () => {
        context.style.display = '';
        context.classList.add('hidden');
        window.dispatchEvent(headerHeightChangeEvent);
      });
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.announcement-bar'), (el) => {
    window.dAgency.initAnnouncementBar(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.announcement-bar'), (el) => {
      window.dAgency.initAnnouncementBar(el);
    });
  });
}
